import React from 'react';
//import { Body1 } from '../components/FontStyles';
//import baseTheme from '../themes/baseTheme';
import Table from '../components/elements/Table';
import ViewContainer from '../components/patterns/ViewContainer';

class PatientList extends React.Component {
  render() {
    return (
      <ViewContainer>
        <Table {...this.props} />
      </ViewContainer>
    );
  }
}

export default PatientList;
